"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../../utils"),
    mixin = _require.mixin;

var EventModifierMixinImpl = require("./EventModifierMixin-impl").implementation;

var UIEventImpl = require("./UIEvent-impl").implementation;

var MouseEventInit = require("../generated/MouseEventInit");

var MouseEventImpl =
/*#__PURE__*/
function (_UIEventImpl) {
  _inherits(MouseEventImpl, _UIEventImpl);

  function MouseEventImpl() {
    _classCallCheck(this, MouseEventImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MouseEventImpl).apply(this, arguments));
  }

  _createClass(MouseEventImpl, [{
    key: "initMouseEvent",
    value: function initMouseEvent(type, bubbles, cancelable, view, detail, screenX, screenY, clientX, clientY, ctrlKey, altKey, shiftKey, metaKey, button, relatedTarget) {
      if (this._dispatchFlag) {
        return;
      }

      this.initUIEvent(type, bubbles, cancelable, view, detail);
      this.screenX = screenX;
      this.screenY = screenY;
      this.clientX = clientX;
      this.clientY = clientY;
      this.ctrlKey = ctrlKey;
      this.altKey = altKey;
      this.shiftKey = shiftKey;
      this.metaKey = metaKey;
      this.button = button;
      this.relatedTarget = relatedTarget;
    }
  }]);

  return MouseEventImpl;
}(UIEventImpl);

mixin(MouseEventImpl.prototype, EventModifierMixinImpl.prototype);
MouseEventImpl.defaultInit = MouseEventInit.convert(undefined);
module.exports = {
  implementation: MouseEventImpl
};